import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { formatNumber } from '../../../../utils/formatters';

// Components
import ClearIcon from '../../../../icons/delete.svg';

// Hooks
import useBonuses from '../useBonus';

// State
import { changeCartSailplayDiscount } from '../../../../state/modules/cart/actions';

// Styles
import styles from './BonusInput.styl';

const cx = classNames.bind(styles);

export default function BonusInput(props) {
  const { className, inputClassname } = props;

  const dispatch = useDispatch();
  const intl = useIntl();

  const { maxBonuses, isInvisible, maxCashbackCanUse, isDisabled, sailplayDiscount } = useBonuses();
  const [isLoading, setIsLoading] = useState(false);
  const [bonuses, setBonuses] = useState('');
  const isBonusInputDisabled = isDisabled && !sailplayDiscount;

  const onSubmit = async () => {
    if (Number(bonuses) <= maxBonuses) {
      setIsLoading(true);
      await dispatch(changeCartSailplayDiscount(Number(bonuses.replace(/[^\d]/g, ''))));
      setIsLoading(false);
    }
  };

  const clearBonusUsing = async () => {
    await setBonuses('');
    onSubmit();
  };

  // если баллы поменялись извне, то поменять и здесь
  useEffect(() => {
    setBonuses('');
  }, [sailplayDiscount]);

  if (isInvisible) {
    return null;
  }

  return (
    <div className={cx('Bonus', className, { Bonus_disabled: isBonusInputDisabled })}>
      <div className={cx('Bonus__field')}>
        {sailplayDiscount > 0 ? (
          <div className={cx('Bonus__applied')}>
            <span>{intl.formatMessage({ id: 'checkout.bonus.spend3' })}</span>
            {': '}
            <span className={cx('Bonus__applied_green')}>
              {formatNumber(sailplayDiscount, 0)} {intl.formatMessage({ id: 'bonus' })}
            </span>
          </div>
        ) : (
          <input
            className={cx('Bonus__input', inputClassname)}
            value={bonuses}
            onChange={v => setBonuses(v.target.value)}
            type="text"
            placeholder={intl.formatMessage({ id: 'checkout.bonus.spend2' })}
            onKeyDown={e => e.key === 'Enter' && !isLoading && onSubmit()}
            readOnly={!!sailplayDiscount || isBonusInputDisabled}
            disabled={isBonusInputDisabled}
          />
        )}
        <button
          className={cx('Bonus__button', {
            Bonus__button_applied: !!sailplayDiscount || isLoading,
            Bonus__button_active:
              (!sailplayDiscount || !isLoading) && !!bonuses && !(Number(bonuses) > maxBonuses),
          })}
          type="button"
          onClick={!sailplayDiscount ? onSubmit : clearBonusUsing}
          disabled={
            isBonusInputDisabled || Number(bonuses) > maxBonuses || maxCashbackCanUse === 0
          }
        >
          {isLoading && <div className={cx('Bonus__button-spinner')} />}
          {!isLoading && !sailplayDiscount && <div className={cx('Bonus__button-arrow')} />}
          {!isLoading && !!sailplayDiscount && (
            <div className={cx('Bonus__button-clear')}>
              <ClearIcon />
            </div>
          )}
        </button>
      </div>
    </div>
  );
}
BonusInput.defaultProps = {
  className: '',
  inputClassname: '',
};

BonusInput.propTypes = {
  className: PropTypes.string,
  inputClassname: PropTypes.string,
};
